<template>
  <div class="d-flex flex-column bg-light align-items-center">
    <header-novo-usuario class="fixed-top" />
    <b-container
      fluid
      class="min-vh-100 d-flex align-items-center justify-content-center"
      style="padding-top: 80px"
    >
      <b-row class="w-100 justify-content-center">
        <b-col cols="12" md="8" lg="6" xl="5">
          <b-card class="text-center p-4">
            <h2
              :class="{
                'text-success mb-3': isProd,
                'text-primary mb-3': isHml,
                'text-secondary mb-3': isDev,
              }"
            >
              Trocar Senha
            </h2>
            <div v-if="!confirmaCodigo">
              <b-overlay :show="loadingCodigo">
                <p>
                  Para redefinir sua senha, primeiro informe o código enviado
                  para o seu e-mail.<br />
                </p>
                <validation-observer
                  ref="validationobserver"
                  v-slot="{ handleSubmit }"
                >
                  <b-form @submit.prevent="handleSubmit(verificarCodigo)">
                    <b-form-group class="mt-3">
                      <default-form-validation-provider
                        label="Código"
                        rules="required"
                        v-slot="state"
                      >
                        <b-form-input
                          id="nova-senha"
                          v-model="codigo"
                          type="text"
                          placeholder="Digite o seu código"
                          :state="state.state"
                          class="text-center"
                        />
                      </default-form-validation-provider>
                    </b-form-group>

                    <b-button
                      :variant="
                        isDev
                          ? 'secondary'
                          : isHml
                          ? 'primary'
                          : 'success'
                      "
                      class="mt-3 w-100"
                      type="submit"
                    >
                      Verificar codigo
                    </b-button>
                  </b-form>
                </validation-observer>
              </b-overlay>
            </div>
            <div v-else>
              <p>
                Para redefinir sua senha, informe a nova senha e confirme
                abaixo.<br />
                Sua senha deve ter pelo menos 8 caracteres.
              </p>
              <validation-observer
                ref="validationobserver"
                v-slot="{ handleSubmit }"
              >
                <b-form @submit.prevent="handleSubmit(trocarSenha)">
                  <b-form-group class="mt-3">
                    <default-form-validation-provider
                      label="Nova senha"
                      rules="required"
                    >
                      <b-form-input
                        v-model="novaSenha"
                        id="nova-senha"
                        placeholder="Digite a nova senha"
                        class="text-center"
                        :state="senhaState"
                        type="password"
                        autocomplete="new-password"
                      />
                    </default-form-validation-provider>
                  </b-form-group>
                  <b-form-group class="mt-3">
                    <default-form-validation-provider
                      label="Confirme a nova senha"
                      rules="required"
                    >
                      <b-form-input
                        v-model="confirmaSenha"
                        id="confirma-senha"
                        :state="senhaState"
                        placeholder="Confirme a nova senha"
                        type="password"
                        autocomplete="new-password"
                        class="text-center"
                      />
                      <b-form-invalid-feedback
                        v-if="senhaState === false"
                        class="text-left"
                      >
                        {{ mensagem }}
                      </b-form-invalid-feedback>
                      <b-form-valid-feedback
                        v-if="senhaState === true"
                        class="text-left"
                      >
                        As senhas coincidem.
                      </b-form-valid-feedback>
                    </default-form-validation-provider>
                  </b-form-group>
                  <b-button
                    :variant="
                      isDev
                        ? 'secondary'
                        : isHml
                        ? 'primary'
                        : 'success'
                    "
                    class="mt-3 w-100"
                    :disabled="!senhaState"
                    type="submit"
                  >
                    Trocar Senha
                  </b-button>
                </b-form>
              </validation-observer>
            </div>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script lang="ts">
import { Component, Ref, Vue } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import { UtilsTS } from "@/utilsts";
import { ValidationObserver } from "vee-validate";
import DefaultFormValidationProvider from "@/components/shared/DefaultFormValidationProvider.vue";
import { isDev, isHml, isProd, store } from "@/store";
import usuarioService from "@/services/administracao/usuarioService";
import HeaderNovoUsuario from "@/components/novo-usuario/Header.vue";

const CompProps = Vue.extend({
  name: "TrocarSenha",
  components: {
    DefaultFormValidationProvider,
    ValidationObserver,
    HeaderNovoUsuario,
  },
});

@Component
export default class RedefinirSenha extends mixins(UtilsTS, CompProps) {
  @Ref("validationobserver") validationobserver!: InstanceType<
    typeof ValidationObserver
  >;
  isDev = isDev();
  isHml = isHml();
  isProd = isProd();
  novaSenha = "";
  confirmaSenha = "";
  confirmaCodigo = false;
  loadingCodigo = false;
  codigo = "";
  mensagem = "";

  mounted() {
    const codigoParam = this.$route.query.codigo;
    this.codigo = `${codigoParam ?? ""}`;
  }

  get senhaState(): boolean | null {
    if (!this.novaSenha || !this.confirmaSenha) return null;
    if (this.confirmaSenha !== this.novaSenha) {
      this.mensagem = "As senhas não coincidem.";
      return false;
    }
    return true;
  }

  async trocarSenha() {
    store.blockScreen = true;
    try {
      if (this.novaSenha !== this.confirmaSenha) {
        return;
      }
      const response = await usuarioService.trocarSenhaEsquecida(
        this.codigo,
        this.novaSenha
      );
      this.$toast.success("Senha alterada com sucesso!");
      this.$router.push("/");
    } catch (e: any) {
      this.tratarError(e);
    } finally {
      store.blockScreen = false;
    }
  }

  async verificarCodigo() {
    this.loadingCodigo = true;
    try {
      const response = await usuarioService.validarCodigoTrocaSenha(
        this.codigo
      );
      this.confirmaCodigo = true;
      return response;
    } catch (e: any) {
      this.tratarError(e);
    } finally {
      this.loadingCodigo = false;
    }
  }
}
</script>

<style scoped>
.text-center {
  font-family: "Montserrat", sans-serif;
}
</style>